package app.bloomey.web.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.silk.components.forms.InputDefaults
import com.varabyte.kobweb.silk.components.forms.TextInput
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.style.ComponentStyle
import com.varabyte.kobweb.silk.components.style.ComponentVariant
import com.varabyte.kobweb.silk.components.style.addVariant
import com.varabyte.kobweb.silk.components.style.toModifier
import org.jetbrains.compose.web.attributes.AutoComplete
import org.jetbrains.compose.web.css.px


val SiteTextInputStyle by ComponentStyle {
    base {
        Modifier.height(58.px)
    }
    cssRule(" input") {
        Modifier.fillMaxWidth()
            .fillMaxHeight()
            .padding(leftRight = 24.px)
            .borderRadius(15.px)
    }
}

val SiteTextInputSearchVariant by SiteTextInputStyle.addVariant {
    base {
        Modifier.height(40.px)
    }
    cssRule(" input") {
        Modifier.width(320.px)
            .borderRadius(12.px)
    }
}

@Composable
fun SiteTextInput(
    modifier: Modifier = Modifier,
    label: String? = null,
    text: String,
    password: Boolean = false,
    leadingImage: String? = null,
    required: Boolean = InputDefaults.Required,
    enabled: Boolean = InputDefaults.Enabled,
    variant: ComponentVariant? = null,
    autoComplete: AutoComplete? = null,
    type: String? = null,
    onCommit: () -> Unit = {},
    onChange: (String) -> Unit,
) {
    Box(modifier = modifier.then(SiteTextInputStyle.toModifier(variant))) {
        if (leadingImage != null)
            Image(
                leadingImage,
                modifier = Modifier.margin(left = 24.px).align(Alignment.CenterStart)
                    .zIndex(1),
                width = 24
            )
        TextInput(
            text = text,
            password = password,
            onTextChanged = onChange,
            required = required,
            enabled = enabled,
            autoComplete = autoComplete,
            modifier = Modifier
                .attrsModifier {
                    if (label != null)
                        attr("name", label)
                    type?.let {
                        attr("type", type)
                    }
                }
                .thenIf(leadingImage != null, Modifier.padding(left = 58.px)),
            placeholder = label,
            onCommit = onCommit
        )
    }
}